import {
  Row,
  Col,
  Container,
  Card,
  CardHeader,
  Button,
  Form,
  CardBody,
  Table,
  FormCheck,
  Alert,
  CardFooter,
  Breadcrumb,
  InputGroup,
  Tabs,
  Tab,
} from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import useCheckAuthorization from "../../hooks/checkAuthorization";
import PaginationComponent from "../common/Pagination";

import {
  PAGE_PERMISSIONS,
  CRUD_PERMISSIONS,
  RESTRICT_ASSIGN_ROLES,
} from "../../constants/user";
import AddFacilitation from "./AddFacilitation";
import {
  createFacilitation,
  updateFacilitation,
  getFacilitation,
  deleteFacilitation,
  resetFacilitationState,
} from "../../slices/facilitationReducer";
import Base from "../Base";
import { FACILITATION_CREATION_FIELDS } from "../../constants/facilitations";
import Loader from "../common/Loader";
import { FaPlus } from "react-icons/fa";
import { truncateText } from "../../utils";
import { extractErrorMessage } from "../../constants/common";
import toast from "react-hot-toast";

export default function ExportImportFacilitation() {
  const [showAddFacilitationModal, setShowAddFacilitationModal] =
    useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedFacilitation, setSelectedFacilitation] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const { client_id } = useParams();
  const { facilitationData, total_count, loading, error, success, successMsg } =
    useSelector((state) => state.facilitation);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleAddFacilitationShow = () => setShowAddFacilitationModal(true);
  const handleAddFacilitationClose = () => {
    setShowAddFacilitationModal(false);
    setIsUpdate(false);
  };
  const hasPermission = useCheckAuthorization(PAGE_PERMISSIONS.user);
  const addPermission = useCheckAuthorization(CRUD_PERMISSIONS.user.add);

  const handleSubmit = async (e, isUpdate, id) => {
    e.preventDefault();
    const name = e.target.name?.value;

    if (!name) {
      setErrors({ name: "Name is required" });
      console.error("Validation Errors: Name is required");
      return;
    }

    try {
      const payload = { name };
      if (!isUpdate) {
      const response = await dispatch(createFacilitation({ data: payload })).unwrap();
      toast.success("Facilitation created successfully!");
    } else {
      const response = await dispatch(updateFacilitation({ data: { ...payload, fes_id: id } })).unwrap();
      toast.success("Facilitation updated successfully!");
    }
      setIsUpdate(false);
      setSelectedFacilitation(null);
      setErrors({});
      handleAddFacilitationClose();
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toast.error(errorMessage);
      setErrors(errorMessage);
    }
  };

  const handlePagination = (pageNumber) => {
    setCurrentPage(pageNumber);
    dispatch(getFacilitation({ page: pageNumber, perpage: 25 }));
  };

  useEffect(() => {
    // if (!hasPermission) {
    //   navigate("/authorization-error");
    // }
    dispatch(getFacilitation({ page: current_page, perpage: 25 }));
    return () => dispatch(resetFacilitationState());
  }, [dispatch, client_id, hasPermission]);

  return (
    <Base hideDatepicker={true}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Container>
            <Row>
              <Col className="mr-auto text-center">
                <Breadcrumb>
                  <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/" }}>
                    Dashboard
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>Facilitation</Breadcrumb.Item>
                </Breadcrumb>
              </Col>
            </Row>
            <div className=" d-flex justify-content-between align-items-center">
              <h2 className="fs-3 fw-semibold">Facilitation</h2>
              <Button className="d-flex align-items-center fw-semibold" variant="primary" onClick={handleAddFacilitationShow}>
                <FaPlus className="me-2" />
                Add New
              </Button>
            </div>
            <Row>
              <Col sm={12}>
                <Card className="border-0 ">
                  <Tabs
                    defaultActiveKey="facilitationList"
                    className=" m-3 custom-tabs"
                    variant="underline"
                  >
                    <Tab eventKey="facilitationList" title="Facilitation List" >
                      <CardBody>
                        <Col>
                          <Table
                            responsive
                            className="core-ui-table"
                          >
                            <thead>
                              <tr>
                                <th className="text-left" scope="col">SL.NO</th>
                                <th className="text-left" scope="col">Name</th>
                                <th className="text-left" scope="col">Created At</th>
                                <th className="text-left" scope="col">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {facilitationData.length ? (
                                facilitationData.map((facilitation, index) => (
                                  <tr key={facilitation.id}>
                                    <td className="text-left">{index + 1}</td>
                                    <td className="text-left">{truncateText(facilitation.name, 20)}</td>
                                    <td className="text-left">{facilitation.created_date.split("T")[0]}</td>
                                    <td className="text-left">
                                      <Button
                                        variant="link"
                                        title="Edit Facilitation"
                                        onClick={() => {
                                          setSelectedFacilitation(facilitation);
                                          setIsUpdate(true);
                                          handleAddFacilitationShow();
                                        }}
                                      >
                                        <i className="ri-pencil-fill"></i>
                                      </Button>
                                      {/* <Button
                                    variant="link"
                                    title="Delete Facilitation"
                                    onClick={() =>
                                      handleDeleteFacilitation(facilitation.id)
                                    }
                                  >
                                    <i className="ri-delete-bin-fill"></i>
                                  </Button> */}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">
                                    No Facilitation Found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                          <PaginationComponent
                            total_count={total_count}
                            current_page={current_page}
                            handleOnClick={handlePagination}
                            per_page={25}
                          />
                        </Col>
                      </CardBody>
                    </Tab>
                  </Tabs>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      )}
      {showAddFacilitationModal && (
        <AddFacilitation
          handleSubmit={handleSubmit}
          fields={FACILITATION_CREATION_FIELDS}
          errors={errors}
          show={handleAddFacilitationShow}
          onHideFunc={handleAddFacilitationClose}
          values={isUpdate ? selectedFacilitation : {}}
          isUpdate={isUpdate}
          id={isUpdate ? selectedFacilitation.id : {}}
        />
      )}
    </Base>
  );
}
